module.exports = __webpack_public_path__ + "morningstarCategoryAsset.3dee2904043fc7d18386b92ddbdc2791.png";